/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { Config } from "../config/Config";

/** Public login aliases never replace the Matrix identity used for permissions. */
export function accountLoginAlias(userId: string): string | undefined {
  const aliases = Config.get().account_login_aliases;
  return aliases && Object.hasOwn(aliases, userId)
    ? aliases[userId]
    : undefined;
}

export function resolveAccountLogin(username: string): string {
  const entered = username.trim();
  // An explicit Matrix ID always identifies that exact account.
  if (entered.startsWith("@")) return entered;
  const server = Config.defaultServerName();
  const match = Object.entries(Config.get().account_login_aliases ?? {}).find(
    ([userId, alias]) =>
      userId.slice(userId.indexOf(":") + 1) === server &&
      alias === entered.toLowerCase(),
  );
  return match?.[0] ?? entered;
}

/** Keep chosen display names; replace only a displayed Matrix login fallback. */
export function accountDisplayName(userId: string, name?: string): string {
  const localpart = userId.replace(/^@/, "").split(":", 1)[0];
  if (!name || name === userId || name === localpart)
    return accountLoginAlias(userId) ?? (name || localpart);
  return name;
}
